import { X } from "lucide-react";
import { AppButton, FigmaTypography } from "@libs/zapi-ui/custom";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@libs/zapi-ui/shadcn";

type TUnsavedChangesDialogProps = {
  open: boolean;
  isSaving?: boolean;
  onClose: () => void;
  onLeaveWithoutSaving: () => void;
  onSaveAndLeave: () => void;
};

export function UnsavedChangesDialog(props: TUnsavedChangesDialogProps) {
  const { open, isSaving = false, onClose, onLeaveWithoutSaving, onSaveAndLeave } = props;

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && !isSaving && onClose()}>
      <DialogContent
        showCloseButton={false}
        onClick={(e) => e.stopPropagation()}
        className="w-[440px] p-5 rounded-xl sm:rounded-xl border-innoveraZinc-100 shadow-[0px_51px_14px_0px_rgba(24,24,27,0),0px_33px_13px_0px_rgba(24,24,27,0),0px_18px_11px_0px_rgba(24,24,27,0.01),0px_8px_8px_0px_rgba(24,24,27,0.01),0px_2px_5px_0px_rgba(24,24,27,0.02)]"
      >
        <DialogHeader className="space-y-1 text-left">
          <DialogTitle className="flex h-8 items-center">
            <FigmaTypography variant="heading-3" color="zinc900">
              Unsaved Changes
            </FigmaTypography>
          </DialogTitle>
          <DialogDescription>
            <FigmaTypography variant="body-2" color="zinc700">
              Your changes won&apos;t be applied until Relaunch Analysis is completed. Save your changes now and
              relaunch later.
            </FigmaTypography>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="items-center sm:space-x-1">
          <AppButton appearance="outlined" color="zinc150" disabled={isSaving} onClick={onLeaveWithoutSaving}>
            Leave Without Saving
          </AppButton>
          <AppButton color="zinc950" isLoading={isSaving} loadingText="Saving…" onClick={onSaveAndLeave}>
            Save &amp; Leave
          </AppButton>
        </DialogFooter>
        <DialogClose className="absolute right-[13px] top-[13px] rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none">
          <X className="size-4" />
          <span className="sr-only">Close</span>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
